import i18n from 'constants/translation/i18n';

const riskAndControlAllocationAreas = (t?: any) => {
  const entries = [
    {
      area: 'allocation',
      title: t ? t('ALLOCATION') : i18n.t('ALLOCATION'),
      href: '/controlsAndRiskAllocation/allocation'
    },
    {
      area: 'process_allocation',
      title: t ? t('PROCESS_ALLOCATION') : i18n.t('PROCESS_ALLOCATION'),
      href: '/controlsAndRiskAllocation/processAllocation'
    }
  ];
  return entries;
};

export default riskAndControlAllocationAreas;
